import { useState, useEffect } from 'react';
import MessageHistory from './components/MessageHistory';
import ConversationView from './components/ConversationView';
import MessageComposer from './components/MessageComposer';
import Navigation from './components/Navigation';

function App() {
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [showComposer, setShowComposer] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(Date.now());
  const [inConversation, setInConversation] = useState(false);

  const handleLogout = () => {
    setSelectedNumber(null);
  };

  const handleBack = () => {
    setSelectedNumber(null);
    setInConversation(false);
  };

  const handleComposerClose = () => {
    setShowComposer(false);
  };

  return (
    <div className="min-h-screen bg-white flex">
      {/* Left Sidebar */}
      <div className="w-16 bg-blue-800 text-white flex flex-col items-center py-4 fixed h-full">
        <div className="mb-8">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
        </div>
        <div className="mb-6 bg-blue-700 p-2 rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
          </svg>
        </div>
        <div className="mb-6">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        </div>
        <div className="mb-6">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        <div className="mt-auto">
          <button onClick={handleLogout} className="text-white hover:text-blue-200">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="ml-16 w-full">
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold text-blue-800">FollowApp <span className="text-blue-500">Care</span></h1>
            <div className="flex items-center space-x-2">
              <select className="bg-white border border-gray-300 rounded-md px-3 py-1 text-sm">
                <option>English (United Kingdom)</option>
              </select>
              <button className="text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
              </button>
            </div>
          </div>
          
          <div className="grid grid-cols-12 gap-6">
            {/* Left side - Interactions/Alerts */}
            <div className="col-span-12 lg:col-span-5">
              <div className="bg-white rounded-lg shadow-lg p-4 mb-6">
                <div className="flex justify-between items-center mb-4">
                  <div className="flex items-center space-x-2">
                    <div className="bg-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold">2</div>
                    <span className="text-gray-700 font-semibold">Unresolved Interactions</span>
                  </div>
                  <div className="text-gray-500">•</div>
                </div>
              </div>
              <MessageHistory
                onSelectNumber={setSelectedNumber}
                selectedNumber={selectedNumber}
                lastUpdate={lastUpdate}
                setInConversation={setInConversation}
              />
            </div>
            
            {/* Right side - Chat */}
            <div className="col-span-12 lg:col-span-7">
              {selectedNumber ? (
                <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                  <ConversationView
                    selectedNumber={selectedNumber}
                    onBack={handleBack}
                    lastUpdate={lastUpdate}
                  />
                </div>
              ) : (
                <div className="bg-white rounded-lg shadow-lg p-4 h-[80vh] flex items-center justify-center">
                  <div className="text-center text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto mb-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                    </svg>
                    <p className="text-lg">Select an interaction from the left to view the conversation</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
